module.exports = __webpack_public_path__ + "static/ios-a16da2f88664fcb72dcea0b92a59f9af.png";